import _merge from "lodash/merge";
import _unionBy from "lodash/unionBy";
import _mergeWith from "lodash/mergeWith";

import * as actionTypes from "../../actions/actionTypes";

function mapMembers(state, mapper) {
  return Object.keys(state).reduce((acc, m) => {
    acc[m] = mapper(state[m]);
    return acc;
  }, {});
}

const spaceMemberReducer = (state = {}, action) => {
  let spaceMembers;
  try {
    spaceMembers = action.response.entities.spaceMembers;
  } catch (error) {
    // That's ok
  }

  switch (action.type) {
    case actionTypes.TRANSFER_SPACE_SUCCESS: {
      const { spaceId } = action;
      return mapMembers(state, m => {
        if (m.spaceId !== spaceId) return m;
        if (m.userId === action.newOwnerId) return { ...m, role: "owner" };
        if (m.role === "owner") return { ...m, role: "admin" };
        return m;
      });
    }
    case actionTypes.CHANGE_SPACE_MEMBER_ROLE: {
      const { spaceId, userId, role } = action,
        memberId = `${spaceId}-${userId}`,
        member = state[memberId];
      return { ...state, [memberId]: { ...member, role } };
    }
    case actionTypes.CHANGE_SPACE_MEMBER_ROLE_FAILURE: {
      const { spaceId, userId, prevRole } = action,
        memberId = `${spaceId}-${userId}`,
        member = state[memberId];

      return { ...state, [memberId]: { ...member, role: prevRole } };
    }
    case actionTypes.CHANGE_SPACE_MEMBER_ROLE_SUCCESS: {
      return _mergeWith({}, state, spaceMembers, (objValue, srcValue, key) => {
        if (key === "kits") {
          return _unionBy(srcValue, objValue, "kitId");
        }
      });
    }
    case actionTypes.FETCH_SPACE_MEMBERS_SUCCESS:
    case actionTypes.DELETE_SPACE_MEMBERS_SUCCESS:
    default: {
      if (spaceMembers) {
        return _merge({}, state, spaceMembers);
      }
      return state;
    }
  }
};

export default spaceMemberReducer;
